import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PasswordSetup from './components/password-setup/PasswordSetup';
import Login from './components/login/Login';
import RecoveryPassword from './components/recovery-password/RecoveryPassword';
import OtpVerification from './components/login/OtpVerification';
import InterviewConfirmPage from './components/interview/InterviewConfirmPage';
import ClarificationResponsePage from './components/clarification/ClarificationResponsePage';
import CandidateConversationPage from './components/conversation/CandidateConversationPage';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsAndConditions from './components/legal/TermsAndConditions';

const PublicRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/user-registrations" element={<PasswordSetup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/otp-verification" element={<OtpVerification />} />
      <Route path="/recovery-password" element={<RecoveryPassword />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route
        path="/interviews/confirm/:token"
        element={<InterviewConfirmPage />}
      />
      <Route
        path="/clarifications/respond/:token"
        element={<ClarificationResponsePage />}
      />
      <Route
        path="/candidate-conversations/:token"
        element={<CandidateConversationPage />}
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default PublicRoutes;
